/**
 *  @author => @RMT_FRONT_CORE/CLI
 * */
import React from 'react';
import settings from 'config/constants';
import { Redirect } from 'react-router-dom';

const CategorySettingsTab = React.lazy(() => import('./views/pages/GRMTCategorySettings'));
const AlertSettingsTab = React.lazy(() => import('./views/pages/GRMTAlertSettings'));
const UniqueCustomSettingPage = React.lazy(() => import('./views/pages/UniqueCustomSettingPage'));
const NotificationSettings = React.lazy(() => import('./views/pages/NotificationSettings'));
const GrmtUserManagementSettings = React.lazy(() => import('./views/pages/GrmtUserManagementSettings'));
const GrmtRoleManagementSettings = React.lazy(() => import('./views/pages/GrmtRoleManagementSettings'));
const GrmtAddRolePage = React.lazy(() => import('./views/pages/GrmtAddRolePage'));

const subUrl = settings.PRODUCTS.GRMT.path;

type Route = {
    path: string,
    name: string,
    exact: boolean,
    page: Function,
    subRoutes?: Array<Route>,
}

const modulePath = `${subUrl}/settings`;

const ROUTES: Array<Route> = [
    { path: `/${modulePath}`, name: 'Settings', exact: true, page: () => <Redirect to={`/${modulePath}/category-settings`} /> },
    { path: `/${modulePath}/category-settings`, name: 'Category Settings', exact: true, page: CategorySettingsTab },

    { path: `/${modulePath}/alert-settings`, name: 'Alert Settings', exact: true, page: AlertSettingsTab },
    { path: `/${modulePath}/alert-settings/:action`, name: 'UniqueCustomSetting', exact: true, secoundart: true, page: () => <UniqueCustomSettingPage /> },
    { path: `/${modulePath}/alert-settings/:action/:id`, name: 'UniqueCustomSetting', exact: true, secoundart: true, page: () => <UniqueCustomSettingPage /> },

    { path: `/${modulePath}/notification-settings`, name: 'Notification Settings', exact: true, page: NotificationSettings },
    { path: `/${modulePath}/user-management`, name: 'User Management Settings', exact: true, page: GrmtUserManagementSettings },
    { path: `/${modulePath}/role-management/edit/:id`, name: 'Edit Role', exact: true, page: GrmtAddRolePage },
    { path: `/${modulePath}/role-management/add`, name: 'Add Role', exact: true, page: GrmtAddRolePage },
    { path: `/${modulePath}/role-management`, name: 'Role Management Settings', exact: true, page: GrmtRoleManagementSettings }
];

export default ROUTES;
